// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2rL80","content":"styles_content__X_5hJ"};